module.exports = __webpack_public_path__ + "img/dg_tape.ab9d16f4.png";